import { HttpParams } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "app/shared/_utils/services/base-crud-service";
import { QueryOperator } from "app/shared/_utils/services/query-operator.enum";
import { LazyLoadEvent } from "primeng/api";
import { PettyCashMaster } from "../entities/petty-cash-master";


@Injectable()
export class PettyCashMasterService extends BaseCrudService<PettyCashMaster> {

  public uri = '/api/pettyCashMaster/';

  constructor(injector: Injector) {
    super(injector);
    // console.log('Instance PettyCashMasterService');
  }

  buildSentence(entity?: PettyCashMaster, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.masterName ?
          `masterName${QueryOperator.Contain}${entity.masterName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.phaseNumber ?
          `phaseNumber${QueryOperator.Contain}${entity.phaseNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.fiscalYear && entity.fiscalYear.id) {
        query = query.concat(
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
        );
      }
      if (entity.executingUnit && entity.executingUnit.id) {
        query = query.concat(
          `executingUnit.id${QueryOperator.Equal}${entity.executingUnit.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }

    // this.httpParams = this.httpParams.set(QueryOperator.SortParam, 'startContractDate');

    return this.httpParams;
  } 

}



// WEBPACK FOOTER //
// ./src/app/core/services/petty-cash-master.service.ts